export const SET_ACTIVE_FILTER = 'SET_ACTIVE_FILTER';
export const SEARCHED_QUERY = 'SEARCHED_QUERY';
export const CLEAR_QUERY = 'CLEAR_QUERY';
export const SET_OFFSET = 'SET_OFFSET';

export const SET_UNVOTED_NUMBER_STARTED = 'SET_UNVOTED_NUMBER_STARTED';
export const SET_UNVOTED_NUMBER_SUCCEED = 'SET_UNVOTED_NUMBER_SUCCEED';
